export default __webpack_public_path__ + "83e08f6a5ce4624633e6b4cf3a9f3775.svg";